const LOCAL_STORAGE_KEY = 'enableReduxLogger'

export function enableReduxLogger() {
  localStorage.setItem(LOCAL_STORAGE_KEY, 'true')
}

export function isReduxLoggerEnabled() {
  return localStorage.getItem(LOCAL_STORAGE_KEY) === 'true'
}
